import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import styled from '@mui/system/styled';

interface ArticleHeadingProps {
  occhiello?: string;
  title?: string;
  data?: string;
}

const StyledOcchiello = styled(Typography)({
  color: "#ff5c04",
  fontSize: "18px",
  fontWeight: "bold",
  letterSpacing: "0",
  lineHeight: "21px",
  margin: "0 0 8px",
});

const StyledTitle = styled(Typography)({
  fontSize: "51px",
  fontWeight: "800",
  letterSpacing: "0",
  lineHeight: "54px",
  marginBottom: "10px",
});

const StyledData = styled(Typography)({
  fontSize: "16px",
  letterSpacing: "0.1px",
  lineHeight: "24px",
  marginBottom: "19px",
});


const ArticleHeading: React.FC<ArticleHeadingProps> = ({ occhiello, title, data }) => {
  return <Box sx={{ position: 'relative', pt: '63px', pb: '18px' }}>
    <Container>
      <Grid container rowSpacing={0}>
        <Grid item xs={0} sm={2}></Grid>
        <Grid item xs={12} sm={8}>
          <Box sx={{ position: 'relative' }}>
            {occhiello &&
              <StyledOcchiello mb={2.5}>{occhiello}</StyledOcchiello>
            }
            <Box sx={{ position: 'relative' }}>
              {title &&
                <StyledTitle mb={2.5}>{title}</StyledTitle>
              }
              {data &&
                <StyledData mb={2.5}>{data}</StyledData>
              }
            </Box>
          </Box>
        </Grid>
        <Grid item xs={0} sm={2}></Grid>
      </Grid>
    </Container>
  </Box>
}

export default ArticleHeading;
